/* eslint-disable @typescript-eslint/no-explicit-any */
import { Theme } from "@mui/material";
import { colors } from "./colors";
import theme from "./default";

export const darkTheme: Theme = {
  ...theme,
  palette: {
    ...theme.palette,
    mode: "dark",
    background: {
      default: colors.black,
      paper: colors.darkCapuccino
    },
    text: {
      primary: colors.white,
      secondary: colors.lightGrey,
      disabled: colors.darkGrey
    }
  },
  components: {
    ...theme.components,
    MuiOutlinedInput: {
      ...theme.components?.MuiOutlinedInput,
      styleOverrides: {
        ...theme.components?.MuiOutlinedInput?.styleOverrides,
        notchedOutline: {
          ...(theme.components?.MuiOutlinedInput?.styleOverrides?.notchedOutline as any),
          borderColor: colors.white
        }
      }
    }
  }
};
